import React, { useState } from "react";
import BreadCrumbComp from "../../components/breadCrumb";
import BiomedicalEquipmentBase from "./biomedicalEquipmentBase";
import { useSelector } from "react-redux";
import { hasAnyRoleUtil } from "../../utils/AuthorizedUtils/360Report";
import { BIOMEDICAL_INVENTORY_EDIT_ROLES } from "../../constants/biomedicalRoles";

const RegisterBiomedicalEquipment = () => {
  const [isBusy, setIsBusy] = useState(false);
  const userData = useSelector((state) => state.userData.userData);

  const canEditInventory = hasAnyRoleUtil(
    BIOMEDICAL_INVENTORY_EDIT_ROLES,
    userData.roleList
  );

  return (
    <div>
      <div inert={isBusy ? "" : undefined}><BreadCrumbComp /></div>
      <div className="searchTitle">
        <h1>DAR ALTA A EQUIPO BIOMÉDICO</h1>
      </div>
      <div className="create-form-container">
        <BiomedicalEquipmentBase isViewer={!canEditInventory} onBusyChange={setIsBusy} />
      </div>
    </div>
  );
};

export default RegisterBiomedicalEquipment;
